import { useFirebaseAuth } from '@smart-maps/firebase';
import Leaflet from 'leaflet';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';

import { TickIcon } from '../../assets';
import { toggleTodo } from '../../redux/actions';
import { MarkerType } from '../../types';

const MapMarkerComponent = React.memo(
  ({ Icon, background, collectible, data }) => {
    const { id, latlng, region } = data;
    const dispatch = useDispatch();
    const { user } = useFirebaseAuth();

    const done = useSelector(_ => _.done);
    const completed = done.find(k => k === id);

    const color = (region && background) || '#000000';

    const DOMString = useMemo(
      () =>
        ReactDOMServer.renderToString(
          <div className="is-relative" data-id={id}>
            <div className="is-absolute">
              <Icon background={color} />
              {completed && <TickIcon />}
            </div>
          </div>
        ),
      [id, color, completed]
    );

    const onClickHandler = useCallback(() => {
      dispatch(toggleTodo(id, user));
    }, [id, user, dispatch]);

    return (
      <Marker
        riseOnHover
        bubblingMouseEvents={false}
        eventHandlers={{ click: onClickHandler }}
        icon={Leaflet.divIcon({
          className: 'leaflet-div-icon',
          html: DOMString,
        })}
        interactive={collectible}
        position={latlng}
      />
    );
  }
);

MapMarkerComponent.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  background: PropTypes.string.isRequired,
  collectible: PropTypes.bool.isRequired,
  data: MarkerType.isRequired,
};

MapMarkerComponent.displayName = 'MapMarkerComponent';

export default MapMarkerComponent;
